/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { MainCoreModule } from '../../../../../../core-modules/main-core-module';

export const MainCoreModuleContext = React.createContext<MainCoreModule>(null);
